"use strict";

(function(z, Backbone){

    var TransferMaterialHistoryModel = Backbone.Model.extend({
        urlRoot: "/api/transferMaterialHistory",
        validation: {

        },

        /**
         * Parses the response and returns the appropriate data
         * @param {Object} response The reponse
         * @return {Object} The data
         */
        parse: function(response){

            if( !_.isUndefined(response.data) ){

                return response.data;
            }

            return response;
        }
    });

    z.TransferMaterialHistoryModel = TransferMaterialHistoryModel;

})(window.z = window.z || {}, Backbone);
